<div [ngClass]="'insecure-screen'">
   <h1>Unauthorized use.</h1>
   <p>To take your exam, you must use the designated browser.</p>
   <p>Current secure browser: {{appName}}</p>
</div>
